export enum UnitOfMeasurementCategoryTypeEnum {
  VOLUME = "VOLUME",
  MASS = "MASS",
  AREA = "AREA",
  LENGTH = "LENGTH",
  UNITS = "UNITS",
}
